import type { Snippet } from "svelte";

export let sidebar = $state<{ snippet: Snippet | null }>({ snippet: null });
